// src/utils/tuki/tukiApi.js
// Fetch wrapper for the operator support-thread list (/api/messages/support/mine).
import { API_URL } from "src/utils/apiUrl";
import { jsonOrThrow, authHeaders } from "src/utils/apiFetch";

export async function listSupportMine({ token, status = "open", limit } = {}) {
    const qs = new URLSearchParams();
    qs.set("status", status);
    if (limit) qs.set("limit", String(limit));
    const res = await fetch(`${API_URL}/api/messages/support/mine?${qs}`, { headers: authHeaders(token) });
    const data = await jsonOrThrow(res);
    return Array.isArray(data?.items) ? data.items : [];
}

// Pure picker for TarjouspyyntoDetail: the newest support thread for one
// pumppuRequest. Items come from listSupportMine (ordered lastMessageAt DESC),
// so .find() = most recent. Returns null when the request has no thread yet.
export function findSupportThreadFor(items, pumppuRequestId) {
    if (!Array.isArray(items)) return null;
    return (
        items.find(
            (t) =>
                t?.contextType === "pumppuRequest" &&
                Number(t?.contextId) === Number(pumppuRequestId)
        ) ?? null
    );
}
